export const NuiMessages = {
	SET_VIEW: 'setView',
	HUD_UPDATE: 'hudUpdate',
	DRIFT_UPDATE: 'driftUpdate',
	COUNTDOWN: 'countdown',
	PRELOADER: 'preloader',
	PRELOADER_HIDE: 'preloaderHide',
	PREPARATION_SCREEN: 'preparationScreen',
	RACE_FRAMES: 'raceFrames',
	FINISH: 'finish',
	VINYLS_EDITOR: 'vinylsEditor',
	HANDLING_DATA: 'handlingData',
	SPEED_DATA: 'speedData',
	VINYL_DATA: 'vinylData',
	VINYL_EDITOR: 'vinylEditor',
	MENU_VINYL: 'menuVinyl',
	FREEROAM_HINT: 'freeroamHint',
	RACE_HINT: 'raceHint',
	TRAINING_HINT: 'trainingHint',
	SHOW_MENU: 'showMenu',
	SHOW_SPEEDOMETER: 'showSpeedometer',
	HIDE_SPEEDOMETER: 'hideSpeedometer',
	SPEEDOMETER_UPDATE: 'speedometerUpdate',
	SET_MAIN_HINT: 'setMainHint',
	EVENT_REGISTER_ERROR: 'eventRegisterError',
} as const

export const NuiCallbacks = {
	CLOSE: 'close',
	EDIT_VINYL: 'editVinyl',
	VINYL_EDITOR_STATE: 'vinylEditorState',
	REQUEST_VINYL_DATA: 'requestVinylData',
	FREEROAM_TELEPORT: 'freeroamTeleport',
	FREEROAM_LEAVE: 'freeroamLeave',
	TOGGLE_DRIFT_HUD: 'toggleDriftHud',
	TOGGLE_DRIFT: 'toggleDrift',
	SAVE_JWT: 'saveJwt',
	FETCH_JWT: 'fetchJwt',
	HIDE_PRELOADER: 'hidePreloader',
	SAVE_LAST_VEHICLE: 'saveLastVehicle',
	FETCH_LAST_VEHICLE: 'fetchLastVehicle',
	ROTATE: 'rotate',
	FETCH_HANDLING: 'fetchHandling',
	FETCH_SPEED: 'fetchSpeed',
	SET_HANDLING: "setHandling",
	SAVE_LAST_CHOSEN_ACTIVITY: 'saveLastChosenActivity',
	FETCH_LAST_CHOSEN_ACTIVITY: 'fetchLastChosenActivity',
	SET_PREVIEW_VEHICLE_COLOR: 'setPreviewVehicleColor',
	TOGGLE_PREVIEW_MARKERS: 'togglePreviewMarkers',
	TOGGLE_PREVIEW_VEHICLE_DOORS: 'togglePreviewVehicleDoors',
	TOGGLE_PREVIEW_VEHICLE_CAMERA: 'togglePreviewVehicleCamera',
	PREVIEW_CURSOR: 'previewCursor',
	PREVIEW_CLICK: 'previewClick',
} as const